import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionIntro } from './components/SolutionIntro';
import { WhatYouReceive } from './components/WhatYouReceive';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { GuaranteeBeforeFAQ } from './components/GuaranteeBeforeFAQ';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Preconnect to CDN for faster image loading
    const preconnectCDN = document.createElement('link');
    preconnectCDN.rel = 'preconnect';
    preconnectCDN.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(preconnectCDN);
    // Preload LCP hero image
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = 'https://cdn.magicpatterns.com/uploads/cK47qtbMUa9xeq7QS1iGs2/mockup_principal.png';
    preloadLink.fetchPriority = 'high';
    document.head.appendChild(preloadLink);
    // Load Google Fonts asynchronously (non-render-blocking)
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    document.head.appendChild(preconnect1);
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect2);
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;700;800;900&family=Inter:wght@400;600;700&display=swap';
    fontLink.media = 'print';
    fontLink.onload = () => {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Meta Pixel Code
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: unknown[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as unknown[][];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      }
    }
    window.fbq('init', '1687764378881323');
    window.fbq('track', 'PageView');
    // Add noscript pixel fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=1687764378881323&ev=PageView&noscript=1';
    noscriptImg.alt = '';
    document.body.appendChild(noscriptImg);
    return () => {
      if (noscriptImg.parentNode) {
        noscriptImg.parentNode.removeChild(noscriptImg);
      }
    };
  }, []);
  return <>
      <div className="w-full min-h-screen bg-white" data-id="element-0">
        <HeroSection data-id="element-1" />
        <PainPoints data-id="element-2" />
        <SolutionIntro data-id="element-3" />
        <WhatYouReceive data-id="element-4" />
        <BonusSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Guarantee data-id="element-8" />
        <GuaranteeBeforeFAQ data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <Footer data-id="element-12" />
        <SocialProofPopup data-id="element-13" />
      </div>
    </>;
}